exports.componentPropsPlugin = require('../lib/next-config/plugins/component-props');
exports.corsHeaderPlugin = require('../lib/next-config/plugins/cors-header');
exports.feaasPlugin = require('../lib/next-config/plugins/feaas');
exports.graphqlPlugin = require('../lib/next-config/plugins/graphql');
